import { useCallback } from 'react';

import { ChatType } from '@anyx/common-graphql';

import { useCrmStore } from '../..';
import { AiAutoReplyConfigForm, AiAutoReplyConfigFormLoader } from '../../components';
import { useStoreAIAutoReplySetting, useUpdateAIAutoReplySetting } from '../../hooks';

interface AIAutoReplyConfigFormContainerProps {
  chatType: ChatType;
}

export const AIAutoReplyConfigFormContainer = ({
  chatType,
}: AIAutoReplyConfigFormContainerProps) => {
  const storeId = useCrmStore((state) => state.storeId);
  const { updateAIAutoReplySetting } = useUpdateAIAutoReplySetting();

  const {
    contextId,
    setContextId,
    contextStoreName,
    systemInstructions,
    setContextStoreName,
    contextStoreOptions,
    contextOptions,
    isLoading,
    hasAiFooter,
  } = useStoreAIAutoReplySetting({
    storeId,
    channel: chatType,
  });

  const onSelectContextStore = (storeName?: string | null) => {
    setContextStoreName(storeName || '');
  };

  const onSelectContextId = (id?: string | null) => {
    setContextId(id || '');
  };

  const onDisable = useCallback(() => {
    if (!contextId) return;

    updateAIAutoReplySetting({
      storeId,
      chatType,
    });
  }, [updateAIAutoReplySetting, storeId, chatType, contextId]);

  if (isLoading) {
    return <AiAutoReplyConfigFormLoader />;
  }

  return (
    <AiAutoReplyConfigForm
      defaultValues={{
        enabled: !!contextId,
        storeId,
        chatType,
        contextStoreName,
        contextId: contextId,
        hasAiFooter,
      }}
      contextStoreOptions={contextStoreOptions}
      contextOptions={contextOptions}
      systemInstructions={systemInstructions}
      onSelectContextStore={onSelectContextStore}
      onSelectContextId={onSelectContextId}
      onSubmit={updateAIAutoReplySetting}
      onDisable={onDisable}
    />
  );
};
